/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { withProcedureWraper } from '../..';
import { Routes } from '../../../../AppRoutes';
import { Box } from '../../../../components/box';
import { Icon } from '../../../../components/icon';
import { InputText } from '../../../../components/input';
import { CreateNotification } from '../../../../components/notifier';
import { Button } from '../../../../modules/button';
import { InputWraper, useForm } from '../../../../modules/form';
import { requestStatus } from '../../../../constants/statusConstants';
import { TrainingService } from '../../../../services/training/training.service';
import { Table } from '../../../../modules/table';
import { getDayInMiSec, getDDMMYYYFormat } from '../../../../helper/dateTimeHelper';

export const ProcedureTrainingPlanCreatePage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const [planCode, setPlanCode] = useState(null as any);

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: 'title',
        label: 'Tên kế hoạch',
      },
      {
        name: 'plancode',
        label: 'Mã kế hoạch',
      },
    ],
    onSubmit: async (payload) => {
      const trainingPlan: any = {
        fields: {
          Title: payload.title,
          PlanCode: payload.plancode,
          eStatus: requestStatus.submitted,
        }
      };
      addTrainingPlan(trainingPlan);
    }
  });

  const genarateUniId = () => {
    return getDayInMiSec();
  }

  const addTrainingPlan = (trainingPlan: any) => {
    if (id != 0) {
      TrainingService.updateTrainingPlan(id, trainingPlan.fields).then(res => {
        CreateNotification({ title: 'Thành công', body: `Chỉnh sửa kế hoạch thành công.`, icon: '/icons/success.png' });
        history.push(Routes.procedureTrainingPlan.path);
      }, error => {
        CreateNotification({ title: 'Thất bại', body: `Chỉnh sửa kế hoạch thất bại.`, icon: '/icons/error.png' });
        console.log(error);
      });
    } else {
      TrainingService.addTrainingPlan(trainingPlan).then(res => {
        CreateNotification({ title: 'Thành công', body: `Tạo kế hoạch thành công.`, icon: '/icons/success.png' });
        history.push(Routes.procedureTrainingPlan.path);
      }, error => {
        CreateNotification({ title: 'Thất bại', body: `Tạo kế hoạch thất bại.`, icon: '/icons/error.png' });
        console.log(error);
      });
    }
  }

  const getCourses = () => {
    return TrainingService.getTrainingCourseByPlanCode(planCode).then(res => {
      return { data: res.reverse(), count: res.length }
    }, () => {
      return { data: [], count: 0 }
    });
  }

  useEffect(() => {
    if (id != 0) {
      TrainingService.getTrainingPlanById(id)
        .then(res => {
          const { Title, PlanCode } = res.fields;
          setPlanCode(PlanCode);
          setValues({ title: Title, plancode: PlanCode });
        })
        .catch(error => console.log(error));
    } else {
      const plancode = genarateUniId();
      setValues({ plancode });
      setPlanCode("0");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <div className="TrainingPlanCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureTrainingPlan.path)}>
              <Icon.ArrowLeft />
            </div>
               Danh sách kế hoạch
            </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            <InputWraper inputProps={getInputProps('plancode')} renderInput={s => <InputText
              {...s}
              isDisabled={true}
            />} />
            <InputWraper inputProps={getInputProps('title')} renderInput={s => <InputText
              {...s}
            />} />
            {id != "0" &&
              <div className="container py-3">
                <Box title="Danh sách lớp học"
                  titleRight={
                    <div className="btnPlus" onClick={() => history.push(Routes.procedureTrainingCourseCreate.path.replace(':plancode', planCode).replace(':id', '0'))}>
                      <Icon.Plus />{'Thêm kế hoạch'}
                    </div>
                  }
                >
                  <Table
                    className="table"
                    onRowClick={(item) => history.push(Routes.procedureTrainingCourseDetail.path.replace(':id', item.id))}
                    structure={[
                      {
                        name: 'Lớp học',
                        render: (item) => item.fields.Title
                      },
                      {
                        name: 'Ngày tổ chức',
                        render: (item) => getDDMMYYYFormat(item.fields.eStartDate)
                      },
                      {
                        name: 'Ngày kết thúc',
                        render: (item) => getDDMMYYYFormat(item.fields.eEndDate)
                      },
                      {
                        name: 'Địa điểm tổ chức',
                        render: (item) => item.fields.eLocation
                      },
                      {
                        name: 'Số lượng học viên',
                        render: (item) => item.fields.eNoOfTrainee
                      },
                      {
                        name: 'Giáo viên',
                        render: (item) => item.fields.eTeacher
                      },
                    ]}
                    onFetchData={getCourses}
                  />
                </Box>
              </div>
            }
            <div className="d-flex justify-content-center">
              <Button type="submit" label="Tạo" isLoading={isSubmitting} />
              <Button type="button" label="Huỷ" buttonType="grey-outline" className="ml10" onClick={() => history.goBack()} />
            </div>
          </form>
        </Box>
      </div>
    </div>
  )
})